import * as index from '@syncfusion/ej2-diagrams';
index.Diagram.Inject( index.HierarchicalTree,index.MindMap,index.RadialTree,index.ComplexHierarchicalTree,index.DataBinding,index.Snapping,index.PrintAndExport,index.BpmnDiagrams,index.SymmetricLayout,index.ConnectorBridging,index.UndoRedo,index.LayoutAnimation,index.DiagramContextMenu,index.ConnectorEditing);
index.SymbolPalette.Inject( index.BpmnDiagrams);
export * from '@syncfusion/ej2-diagrams';
